import React from 'react'

import axios from "axios";
import config from "../config";
import { Button, Grid, TextField } from '@material-ui/core/'

import FriendSearchResults from "./FriendSearchResults";

class FriendSearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            friendSearchText: '',
            friendSearchResults: undefined,
            systemMessage: {}
        }
    }

    searchFormChangeHandler = e => {
        const target = e.target
        const value = target.value
        const name = target.name

        this.setState({
            [name]: value
        })
    }

    searchFormSubmit = e => {
        e.preventDefault()

        axios
            .get(
                config.apiServer +
                '/api/v3/web/social/users?n=' +
                this.state.friendSearchText +
                '&aid=' +
                this.props.aid,
                {}
            )
            .then(
                response => {
                    const json = response.data

                    if (json.key === 'OK') {
                        const resultsJson = json.results
                        const resultsCount = resultsJson.length

                        let resultsFriends = []

                        if (resultsCount > 0) {
                            // Fetch the friends and put each bit of JSON into an array
                            for (let i = 0; i < resultsCount; i++) {
                                resultsFriends.push(resultsJson[i])
                            }
                        }

                        this.setState((state, props) => ({
                            friendSearchResults: resultsFriends
                        }))
                    } else {
                        console.log(response)

                        this.setState({
                            systemMessage: {
                                message:
                                    'There was an error while searching for friends. Please try again later.',
                                type: 'error',
                                duration: 6000,
                                timestamp: new Date().getTime()
                            }
                        })
                    }
                },
                error => {
                    console.log(error)

                    this.setState({
                        systemMessage: {
                            message:
                                'There was an error while searching for friends. Please try again later.',
                            type: 'error',
                            duration: 6000,
                            timestamp: new Date().getTime()
                        }
                    })
                }
            )
    }

    render() {
        return (
            <div>
                <form
                    id="friend-search"
                    className="text-center"
                    style={{marginBottom: '3em'}}
                    method="post"
                    onSubmit={e => {
                        this.searchFormSubmit(e)
                    }}
                >
                    <div className="text-center">
                        <h2>Search the Cook'n Network</h2>
                        <p>
                            This feature allows you to connect with people who already
                            have&nbsp;<span className="dvo-secondary">Cook'n</span>.
                            <br/>
                            Simply enter a name or email address to search the Cook'n
                            Network and then click&nbsp;"Invite."
                        </p>
                    </div>

                    <TextField
                        id="friend-search-text"
                        name="friendSearchText"
                        label="Name or Email Address"
                        margin="dense"
                        variant="outlined"
                        fullWidth
                        required
                        onChange={this.searchFormChangeHandler}
                    />
                    <p>
                        <Button variant="contained" color="primary" type="submit">
                            Search
                        </Button>
                    </p>
                </form>

                <FriendSearchResults
                    device={this.props.device}
                    aid={this.props.aid}
                    results={this.state.friendSearchResults}
                    sendInternalInvite={this.props.sendInternalInvite}
                />
            </div>
        )
    }
}

export default FriendSearch


// WEBPACK FOOTER //
// ./src/Components/FriendSearch.js